export const AUTH_PATH = {
     LOGIN: '/login/',
     REGISTER: '/register/',
     PASSWORD_FORGOT: '/password/forgot/',
     PASSWORD_RESET: '/password/reset/:token/',
     UNSUBSCRIBE_EMAIL: '/unsubscribe/:dataEncode/',
};

export const SYSTEM_ADMIN_ROUTES = '/admin/';
export const SYSTEM_ADMIN_PATH = {
     DASHBOARD: `${SYSTEM_ADMIN_ROUTES}`,
     ORDERS: `${SYSTEM_ADMIN_ROUTES}orders/`,
     ORDER_FILTER: `${SYSTEM_ADMIN_ROUTES}orders:filter`,
     ORDERS_DETAILS: `${SYSTEM_ADMIN_ROUTES}orders/:id/`,
     ORDERS_REFUND: `${SYSTEM_ADMIN_ROUTES}order-refund/`,
     ORDERS_REFUND_FILTER: `${SYSTEM_ADMIN_ROUTES}order-refund:filter`,
     EVENT_CREDITS: `${SYSTEM_ADMIN_ROUTES}event-credits/`,
     EVENT_CREDIT_FILTER: `${SYSTEM_ADMIN_ROUTES}event-credits:filter`,
     BUNDLED_SEATS: `${SYSTEM_ADMIN_ROUTES}bundled-seats/`,
     BUNDLED_SEAT_FILTER: `${SYSTEM_ADMIN_ROUTES}bundled-seats:filter`,
     SHIPMENTS: `${SYSTEM_ADMIN_ROUTES}shipments/`,
     SHIPMENT_FILTER: `${SYSTEM_ADMIN_ROUTES}shipments:filter`,
     INTEGRATIONS: `${SYSTEM_ADMIN_ROUTES}integrations/`,
     SOW_ORDERS: `${SYSTEM_ADMIN_ROUTES}sow-orders/`,
     SOW_ORDER_FILTER: `${SYSTEM_ADMIN_ROUTES}sow-orders:filter`,
     SOW_ORDERS_DETAILS: `${SYSTEM_ADMIN_ROUTES}sow-orders/:id`,
     ORGANIZATIONS: `${SYSTEM_ADMIN_ROUTES}organizations/`,
     ORGANIZATION_FILTER: `${SYSTEM_ADMIN_ROUTES}organizations:filter`,
     ORGANIZATIONS_DETAILS: `${SYSTEM_ADMIN_ROUTES}organizations/:id/`,
     USERS: `${SYSTEM_ADMIN_ROUTES}users/`,
     USER_FILTER: `${SYSTEM_ADMIN_ROUTES}users:filter`,
     USERS_DETAILS: `${SYSTEM_ADMIN_ROUTES}users/:id/`,
     INSTRUCTORS: `${SYSTEM_ADMIN_ROUTES}instructors/`,
     INSTRUCTORS_CREATE: `${SYSTEM_ADMIN_ROUTES}instructors/create/`,
     INSTRUCTORS_DETAIL: `${SYSTEM_ADMIN_ROUTES}instructors/:id/`,
     LICENSEES: `${SYSTEM_ADMIN_ROUTES}licensees/`,
     PARTNERS: `${SYSTEM_ADMIN_ROUTES}partners/`,
     TRAINING_PRODUCTS: `${SYSTEM_ADMIN_ROUTES}training-products/`,
     TRAINING_PRODUCTS_CREATE: `${SYSTEM_ADMIN_ROUTES}training-products/create/`,
     TRAINING_PRODUCTS_DETAIL: `${SYSTEM_ADMIN_ROUTES}training-products/:id/`,
     TRAINING_PRODUCTS_UPDATE: `${SYSTEM_ADMIN_ROUTES}training-products/:id/update/`,
     EVENTS: `${SYSTEM_ADMIN_ROUTES}training-products/:id/events/`,
     EVENTS_CREATE: `${SYSTEM_ADMIN_ROUTES}training-products/:id/events/create/`,
     EVENTS_DETAIL: `${SYSTEM_ADMIN_ROUTES}training-products/:id/events/:idEvent/`,
     SURVEYS: `${SYSTEM_ADMIN_ROUTES}surveys/`,
     SURVEYS_CREATE: `${SYSTEM_ADMIN_ROUTES}surveys/create/`,
     SURVEYS_DETAIL: `${SYSTEM_ADMIN_ROUTES}surveys/:id/`,
     CE_PACKS: `${SYSTEM_ADMIN_ROUTES}ce-packs/`,
     CE_PACKS_CREATE: `${SYSTEM_ADMIN_ROUTES}ce-packs/create/`,
     CE_PACKS_DETAIL: `${SYSTEM_ADMIN_ROUTES}ce-packs/:id/`,
     TESTS: `${SYSTEM_ADMIN_ROUTES}tests/`,
     TESTS_DETAIL: `${SYSTEM_ADMIN_ROUTES}tests/:id/`,
     QUESTIONS: `${SYSTEM_ADMIN_ROUTES}questions/`,
     TEST_QUESTIONS_DETAIL: `${SYSTEM_ADMIN_ROUTES}tests/:id/questions/:questionId/`,
     TEST_USER_TESTS: `${SYSTEM_ADMIN_ROUTES}tests/:id/user-tests`,
     TEST_USER_TEST_DETAILS: `${SYSTEM_ADMIN_ROUTES}tests/:id/user-tests/:userId/`,

     SURVEY_QUESTIONS_DETAIL: `${SYSTEM_ADMIN_ROUTES}surveys/:id/questions/:questionId/`,
     SURVEY_USER_SURVEYS: `${SYSTEM_ADMIN_ROUTES}surveys/:id/user-surveys`,
     SURVEY_USER_SURVEY_DETAILS: `${SYSTEM_ADMIN_ROUTES}surveys/:id/user-surveys/:userSurveyId/`,
     ANSWERS: `${SYSTEM_ADMIN_ROUTES}answers/`,
     DESIGNATION_ELEMENTS: `${SYSTEM_ADMIN_ROUTES}designation-elements/`,
     DESIGNATION_ELEMENTS_CREATE: `${SYSTEM_ADMIN_ROUTES}designation-elements/create/`,
     DESIGNATION_ELEMENTS_DETAIL: `${SYSTEM_ADMIN_ROUTES}designation-elements/:id/`,
     SELLING_GROUPS: `${SYSTEM_ADMIN_ROUTES}selling-groups/`,
     SELLING_GROUP_CATEGORIES: `${SYSTEM_ADMIN_ROUTES}selling-group-categories/`,
     USER_GROUPS: `${SYSTEM_ADMIN_ROUTES}user-groups/`,
     ORGANIZATION_GROUPS: `${SYSTEM_ADMIN_ROUTES}organization-groups/`,
     PROFILE: `${SYSTEM_ADMIN_ROUTES}profile/`,
     CERTIFICATES: `${SYSTEM_ADMIN_ROUTES}certificates/`,
     LESSONS: `${SYSTEM_ADMIN_ROUTES}lessons/`,
     LESSONS_CREATE: `${SYSTEM_ADMIN_ROUTES}training-products/:id/lessons/create/`,
     LESSONS_DETAIL: `${SYSTEM_ADMIN_ROUTES}training-products/:id/lessons/:lessonId/`,
     PRODUCT_TYPES: `${SYSTEM_ADMIN_ROUTES}product-types/`,
     COUPONS: `${SYSTEM_ADMIN_ROUTES}coupons/`,
     SURVEY_REPORTS: `${SYSTEM_ADMIN_ROUTES}survey-reports/`,
     SHIPPING_REPORTS: `${SYSTEM_ADMIN_ROUTES}shipping-reports/`,
     TRAINING_PRODUCT_REPORTS: `${SYSTEM_ADMIN_ROUTES}training-product-reports/`,
     SEAT_AVAILABILITY_REPORTS: `${SYSTEM_ADMIN_ROUTES}seat-availability-reports/`,
     CE_REPORTS: `${SYSTEM_ADMIN_ROUTES}ce-reports/`,
     DESIGNATION_REPORTS: `${SYSTEM_ADMIN_ROUTES}designation-reports/`,
     ORDER_REPORTS: `${SYSTEM_ADMIN_ROUTES}order-reports/`,
     SHIPPING_REPORT_FILTER: `${SYSTEM_ADMIN_ROUTES}shipping-reports:filter`,
     ORGANIZATION_TRAINING_REPORTS: `${SYSTEM_ADMIN_ROUTES}organization-training-reports/`,
     SOW_TOTAL_ORDER_REPORTS: `${SYSTEM_ADMIN_ROUTES}sow-total-order-reports/`,
     SOW_TRAINING_USAGE_REPORTS: `${SYSTEM_ADMIN_ROUTES}sow-training-usage-reports/`,
     VOUCHERS: `${SYSTEM_ADMIN_ROUTES}vouchers/`,
     VOUCHER_RULES: `${SYSTEM_ADMIN_ROUTES}vouchers#voucher-rules/`,
     VOUCHER_CODES: `${SYSTEM_ADMIN_ROUTES}vouchers#voucher-codes/`,
     VOUCHER_RULES_FILTER: `${SYSTEM_ADMIN_ROUTES}vouchers#voucher-rules:filter`,
     VOUCHER_CODES_FILTER: `${SYSTEM_ADMIN_ROUTES}vouchers#voucher-codes:filter`,
     UNIVERSAL_CONTENT_MANAGEMENT: `${SYSTEM_ADMIN_ROUTES}universal-content-managements/`,
     REDIS: `${SYSTEM_ADMIN_ROUTES}redis/`,
};

export const GUEST_PATH = {
     HOME: `/`,
     DESIGNATION: `training-certification/`,
     PAYMENT_SUCCESS: `/checkout/payment-success/`,
     SELLING_GROUPS: `/products/`,
     SELLING_GROUPS_DETAIL: `/products/:slug/`,
     CART: `/cart/`,
     CHECKOUT: `/checkout/`,
     ACCEPT_YOUR_SEATS: `/accept-your-seats/:token/`,
     VERIFY_SEAT: `/verify-seat/:token/`,
     CONFIRM_ALTERNATE_EMAIL: `confirm-alternate-email/:dataAlternateEmail/`,
     CLINICIAN_LOCATOR: `clinician-locator`,
     PREVIEW_PDF: '/drm/:slug/:id',
     MY_ACCOUNT_SETTINGS_ADMIN: '/my-learning/my-account-settings/',
};

export const ACCOUNT_SETTINGS_ROUTES = '/account-settings/';
export const ACCOUNT_SETTINGS_PATH = {
     DASHBOARD: ACCOUNT_SETTINGS_ROUTES,
};

export const MY_LEARNING_ROUTES = '/my-learning/';
export const MY_LEARNING_PATH = {
     DASHBOARD: MY_LEARNING_ROUTES,
     MY_ACCOUNT_SETTINGS: `${MY_LEARNING_ROUTES}my-account-settings/`,
     MY_PURCHASES: `${MY_LEARNING_ROUTES}purchases/`,
     ORGANIZATION: `${MY_LEARNING_ROUTES}organizations/`,
     MY_TRAINING: `${MY_LEARNING_ROUTES}my-training/`,
     COURSE_PRODUCT_DETAILS: `${MY_LEARNING_ROUTES}my-training/:slug/`,
     COURSE_CATEGORIES_DETAILS_LESSONS: `${MY_LEARNING_ROUTES}my-training/:slug/:courseId/lessons/`,
     COURSE_CATEGORIES_DETAILS_LESSON_DETAIL: `${MY_LEARNING_ROUTES}my-training/:slug/:courseId/lessons/:userLessonId/`,
     COURSE_EVENT_DETAILS: `${MY_LEARNING_ROUTES}my-training/:slug/event/:eventId/`,
     TAKE_SURVEY: `${MY_LEARNING_ROUTES}my-training/:slug/:courseId/survey/`,
     TAKE_TEST: `${MY_LEARNING_ROUTES}my-training/:slug/:courseId/test/:testId/`,
     MY_CE_CERTIFICATES: `${MY_LEARNING_ROUTES}my-ce-certificates/`,
     MY_CE_OF_COMPLETION: `${MY_LEARNING_ROUTES}my-ce-of-training/`,
     MY_PROFESSIONAL_DETAIL: `${MY_LEARNING_ROUTES}my-professional-details/`,
     MY_DESIGNATION: `${MY_LEARNING_ROUTES}my-designations/`,
     SELLING_GROUPS_CATEGORY: `${MY_LEARNING_ROUTES}:sellingGroupCategorySlug/`,
     TAKE_TEST_TRAINING: `${MY_LEARNING_ROUTES}my-training/:slug/event/:eventId/:courseId/test/:testId/`,
     TAKE_SURVEY_TRAINING: `${MY_LEARNING_ROUTES}my-training/:slug/event/:eventId/:courseId/survey/`,
};

export const MY_ORG_ROUTES = '/my-organization/';
export const MY_ORG_PATH = {
     ORGANIZATIONS_DASHBOARD: MY_ORG_ROUTES,
     ORGANIZATIONS_ACCOUNT_SETTINGS: `${MY_ORG_ROUTES}organization-settings/`, // TODO: remove this
     ORGANIZATIONS_ADMIN_USERS: `${MY_ORG_ROUTES}admin-users/`, // TODO: remove this
     ORGANIZATIONS_ORG_MEMBERS: `${MY_ORG_ROUTES}users-groups/organization-users/`,
     ORGANIZATIONS_USERS_GROUPS: `${MY_ORG_ROUTES}users-groups/`,
     ORGANIZATIONS_ORG_MEMBERS_DETAILS: `${MY_ORG_ROUTES}users-groups/organization-users/:id/`,
     ORGANIZATIONS_PURCHASES: `${MY_ORG_ROUTES}purchases/`,
     ORGANIZATIONS_TRAINING_GROUPS: `${MY_ORG_ROUTES}users-groups/training-groups/`,
     ORGANIZATIONS_TRAINING_GROUPS_DETAILS: `${MY_ORG_ROUTES}users-groups/training-groups/:id/`,
     ORGANIZATIONS_COURSES: `${MY_ORG_ROUTES}courses/`,
     ORGANIZATIONS_COURSE_CATEGORIES_DETAILS: `${MY_ORG_ROUTES}courses/:slug/`,
     ORGANIZATIONS_COURSE_TRAINING_DETAILS: `${MY_ORG_ROUTES}courses/:slug/:courseId/`,
     ORGANIZATIONS_COURSE_CATEGORIES_DETAILS_SEATS: `${MY_ORG_ROUTES}courses/:slug/:courseId/seats/`,
     ORGANIZATIONS_COURSE_CATEGORIES_DETAILS_BUNDLE_SEATS: `${MY_ORG_ROUTES}courses/:slug/:courseId/bundle-seats/`,
     ORGANIZATIONS_COURSE_EVENT_DETAILS: `${MY_ORG_ROUTES}courses/:slug/event/:eventId/`,
     ORGANIZATIONS_COURSE_CATEGORIES_DETAILS_SEATS_EVENT: `${MY_ORG_ROUTES}courses/:slug/event/:eventId/:courseId/seats`,
     ORGANIZATIONS_COURSE_CATEGORIES_DETAILS_EVENT_CREDITS: `${MY_ORG_ROUTES}courses/:slug/event-no-date/:courseId/seats`,
     ORGANIZATIONS_REPORTING: `${MY_ORG_ROUTES}reporting`,
     ORGANIZATIONS_REPORTING_COMPLETION_REPORT: `${MY_ORG_ROUTES}reporting/completion-reports/`,
};

export const SUBSCRIBER_PATH = {
     ...GUEST_PATH,
     ...ACCOUNT_SETTINGS_PATH,
     ...MY_ORG_PATH,
     ...MY_LEARNING_PATH,
};
